import { AxiosResponse } from 'axios';
import Api from '../api';
import { ModuleType } from '../modules.types';

const UpdateApi = ({
  moduleType,
  id,
  data,
}: {
  moduleType: ModuleType;
  id: number;
  data: any;
}): Promise<AxiosResponse> => {
  const path = `/admin/${moduleType}/edit/${id}`;
  return Api.getInstance().request.put(path, data);
};
export default UpdateApi;
